import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import CustomLabel from "../../../components/ceo/analysis/competitive/charts/custom-label";
import TooltipContent from "../../../components/ceo/analysis/competitive/charts/tooltip-content";

function HorizontalBar({
  prefix = "",
  suffix = "",
  precision = 2,
  data = [],
  barSize = 18,
  colors = [],
  height = 200,
  xAxisLine = true,
  xAxisTick = false,
  hideYAxis = true,
  showBarLabel = false,
  showIntegerLabel = false
}) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} barSize={barSize}>
        <XAxis dataKey="name" tickLine={false} tick={xAxisTick} axisLine={xAxisLine} />
        <YAxis hide={hideYAxis} axisLine={false} tickLine={false} />
        <Tooltip content={<TooltipContent prefix={prefix} suffix={suffix} />} />
        <Bar
          dataKey="value"
          minPointSize={5}
          isAnimationActive={!showBarLabel}
          label={
            <CustomLabel
              prefix={prefix}
              suffix={suffix}
              precision={precision}
              showIntegerLabel={showIntegerLabel}
            />
          }
        >
          {colors.map((color, i) => (
            <Cell key={i} fill={color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default HorizontalBar;



// WEBPACK FOOTER //
// ./src/instructor/components/charts/horizontal-bar.js